// extracted by mini-css-extract-plugin
export default {"card":"courses_card__i7eDt","cardImage":"courses_cardImage__X8LGD","cardImg":"courses_cardImg__vIlFp"};